import React from 'react';
import './ScoreGauge.css';

const ScoreGauge = ({ 
  value, 
  maxValue = 100, 
  label, 
  size = 'medium',
  showLabel = true,
  variant = 'bar'
}) => {
  const normalizedValue = value ?? 0;
  const percentage = Math.min(100, Math.max(0, (normalizedValue / maxValue) * 100));
  
  const getColor = (pct) => {
    if (pct >= 75) return { gradient: 'linear-gradient(90deg, #4A7BDB, #6495ED)', glow: 'rgba(100, 149, 237, 0.4)' };
    if (pct >= 60) return { gradient: 'linear-gradient(90deg, #059669, #10b981)', glow: 'rgba(16, 185, 129, 0.4)' };
    // 40, matching the pillar chips' Strong / Mixed / Weak (utils/convictionLabel pillarStep).
    if (pct >= 40) return { gradient: 'linear-gradient(90deg, #d97706, #fbbf24)', glow: 'rgba(251, 191, 36, 0.4)' };
    return { gradient: 'linear-gradient(90deg, #dc2626, #f87171)', glow: 'rgba(248, 113, 113, 0.4)' };
  };
  
  const colors = getColor(percentage);
  const displayValue = maxValue === 5 ? normalizedValue.toFixed(1) : Math.round(normalizedValue);

  if (variant === 'compact') {
    return (
      <div className={`score-gauge-compact score-gauge-${size}`}>
        <span className="score-gauge-value-compact" style={{ color: percentage >= 60 ? '#10b981' : percentage >= 40 ? '#fbbf24' : '#f87171' }}>
          {displayValue}
        </span>
        {showLabel && label && <span className="score-gauge-label-compact">{label}</span>}
      </div>
    );
  }

  return (
    <div className={`score-gauge score-gauge-${size}`}>
      {showLabel && label && (
        <div className="score-gauge-header">
          <span className="score-gauge-label">{label}</span>
          <span className="score-gauge-value">{displayValue}</span>
        </div>
      )}
      <div className="score-gauge-track">
        <div className="score-gauge-fill" style={{ width: `${percentage}%`, background: colors.gradient, boxShadow: `0 0 12px ${colors.glow}` }} />
      </div>
    </div>
  );
};

export default ScoreGauge;
